export default __webpack_public_path__ + "static/media/united-kingdom.b67ba79a.png";